export default {
  bondsAgreeContext: '本人確認清楚明白及同意上述有關申請開通交易債券的風險披露及聲明',
  bondsTitle: '債務風險披露及聲明',
  error: '請確保您已開通證券賬號(現金)或證券賬號(保證金)',
  successMessage: '開通成功',
  successTips: '您已成功開通債券交易權限，請前往理財頁面與我們進行預約。 ',
  errorMessage: {
    '5004': '獲取用戶郵箱模板失敗，請聯繫客服',
    '5005': '獲取用戶郵箱失敗，請聯繫客服',
    '5006': '獲取用戶語言失敗，請聯繫客服',
    '5007': '獲取返回數據失敗，請聯繫客服',
    '20105': '請仔細閱讀並勾選協議',
    '20101': '沒有同意聲明，開通失敗',
    '20100': '已經開通買賣債券，無法創建',
    '20102': '賬戶信息不存在，開通失敗',
    '20103': '交易賬戶信息列表不存在，開通失敗',
    '20104': '請確保您已開通證券賬號(現金)或證券賬號(保證金)並可正常使用'
  },
  statementContext: `<div>
  <h5>以下重要資料</h5>
  <p>在繼續瀏覽前，請先細閱重要信息，並勾選「本人確認清楚明白及同意上述債券的風險披露及聲明」以確認您已理解。 </p>
  <h5>獨立中介人</h5>
  <p>艾德證券期貨有限公司於債券銷售是獨立的中介人，理由如下：</p>
  <p>1. 我們沒有收取由其他人士就我們向閣下分銷任何債券產品而提供的費用、佣金或任何其他金錢收益；及</p>
  <p>2. 我們與債券發行人沒有任何緊密聯繫或其他法律或經濟關係，或沒有從任何人士取得任何非金錢收益，而這些聯繫、關係或收益可能損害我們的獨立性，使我們偏向任何特定債券產品、任何債券產品類別或任何債券發行人。 </p>
  <h5>產品主要風險</h5>
  <p>投資者在決定是否投資該產品前，應審慎閱讀相關產品認購書（如適用）所披露的細節及風險。主要風險包括但不限於下頁所載：</p>
  <p>1.流動性風險</p>
  <p>債券的流動性可能有限，及可能無活躍交易，及/或沒有經紀在市場提供報價，因此：</p>
  <p>2.信貸風險</p>
  <p>投資者須承擔發債機構及擔保機構（如適用）的信貸風險，他們的信貸評級如有任何變動將會影響本債券的價格及價值。債券附帶發債機構違責的風險，即發行機構有機會未能如期支付本金和利息。在最壞的情況下如發行人及擔保人（如適用）破產，投資者可能會損失全部投資。信貸評級機構給予的信貸評級並非對發債機構信用可靠程度的保證。 </p>
  <p>(i) 不可能在任何時間均能提供債券的市值及/或參考買入/賣出價，因其將取決於市場的流動性和情況；</p>
  <p>(ii) 可能需要較長時間或無法於市場上出售債券；及</p>
  <p>(iii) 所執行的賣出價可能與本行參考買入價有很大的差別，對投資者不利。 </p>
  <p>3.利率風險</p>
  <p>債券較易受到利率波動的影響。一般來說，利率上升，債券價格便會下跌。 </p>
  <p>4.市場風險</p>
  <p>投資價值可能會因政治、法律、經濟條件及利率變化而有波動。這些變化在全部市場及資產類別上都很普遍，投資者取回的投資金額有可能少於初次投放的資金。 </p>
  <p>5.外幣風險</p>
  <p>以外幣報價之債券，當把贖回之金額轉換為本土或基本貨幣時，投資者有可能出現兌換損失。 </p>
  <h5>只適用於以人民幣發行或掛鉤資產以人民幣發行之產品</h5>
  <p>人民幣與外幣（包括港元）的兌換須受中國的規管限制–人民幣現時並非自由兌換的貨幣及透過香港銀行兌換人民幣須受若干限制。香港特區及中國內地兩地的人民幣與外幣兌換是受中國政府規管，此舉或會影響流通量。 </p>
  <h5>高息產品風險</h5>
  <p>投資於高息債券，除以上列舉的一般風險外，還須承受其他風險，例如：</p>
  <p>1.較高的信貸風險</p>
  <p>高息債券的評級通常低於投資級別，或不獲評級，因此涉及的發債機構違責風險往往較高</p>
  <p>2.受制於經濟周期的轉變</p>
  <p>經濟下滑時，高息債券價值的跌幅往往會較投資級別債券為大，原因是(i)投資者會較為審慎，不願承擔風險；(ii)違責風險加劇。 </p><h5>某些債券可能別具特點及風險，投資時須格外注意。這些包括：</h5>
  <p>1.永續性債券的風險</p>
  <p>永續性債券不設到期日，其利息派付取決於發債機構在非常長遠的時間內的存續能力，利息或會因根據其條款及細則而有所延遲或終止。一般而言，永續性債券一般為可贖回及/或為後償債券，投資者須要承受再投資風險/或為後償債券風險，詳情如下。 </p>
  <p>2.可提早贖回債券的再投資風險</p>
  <p>如果這是可提早贖回的債券，當發行人在債券到期前行使贖回權利，債券持有人或面臨再投資風險。發行人行使贖回權利常見於利率在債券發行後大幅回落的環境；再投資風險是指將票息收入和本金進行再投資的收益率低於購買債券時的預期收益率之風險；由於內含贖回權，可贖回債券現金流的可預測性並不明確；可贖回債券的贖回計劃或有不同的贖回日，而贖回價格則視乎不同的贖回時間而定；相對不含贖回權的同類債券而言，由於債券價格受贖回價所限，可贖回債券價格的潛在升幅有限。當發債機構於債券到期前行使贖回權，投資者便會面對再投資風險。投資者於再投資時可能會收到較小的孳息率。 </p>
  <p>3.後償債券的風險</p>
  <p>後償債券於發債機構遣債後的清盤過程中獲較低之索償權，因此後償債券之持有人將承受比優先債券更高的風險。後償債券為無抵押，其信貸評級及債務的優先次序較優先債券為低。投資者應特別注意產品之信貸資料，包括發債機構，債券或擔保人的信貸評級(視情況而定)。 </p>
  <p>4.浮息及／或延遲派付利息的風險</p>
  <p>如果債券具有浮息及／或延遲派付利息的條款，投資者便無法確定將收取的利息金額及利息派付的時間。 </p>
  <p>5.可延遲到期日的風險</p>
  <p>如果債券具有可延遲到期日的條款，投資者便沒有一個訂明償還本金的確實時間表。 </p>
  <p>6.股票及債券的投資風險</p>
  <p>屬可換股或可交換性質的債券，投資者須同時承受股票及債券的投資風險；及／或具有或然撇減或彌補虧損特點的債券。當發生觸發事件時，這些債券可能會作全數或部分撇賬，或轉換為普通股。 </p></div>`
}
